import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import {
    Card,
    Col,
    Container,
    Input,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane
} from 'reactstrap';
import { Tooltip } from 'antd';

// actions
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { getCoordinations } from '../../store/catalogs/Coordinations/actions';
import { getServiceTypes } from '../../store/catalogs/ServiceTypes/actions';
import { getCustomers } from '../../store/catalogs/Customers/actions';
import { getLabAreas } from '../../store/catalogs/LabAreas/actions';
import { getLabs } from '../../store/catalogs/Laboratories/actions';
import { getLabSegments } from '../../store/catalogs/LabSegments/actions';
import { getProducts } from '../../store/catalogs/Products/actions';
import { getRegions } from '../../store/catalogs/Regions/actions';
import { getUsers } from '../../store/catalogs/Users/actions';
import { getLabTypes } from '../../store/catalogs/LabTypes/actions';
import { addNewLabRequest, getLabRequest, getLabRequests, updateLabRequest } from '../../store/labCitec/labRequest/actions';

import classnames from 'classnames';
import 'react-toastify/dist/ReactToastify.css';
import Breadcrumb from '../../components/Common/Breadcrumb';
import { ConfirmationModal } from '../../components/Common/ConfirmationModal';
import { NewServiceRequestButton } from '../../components/Common/NewServiceRequestButton';
import Table1 from '../../components/Common/TableContainer';
import { mainRequestStatusFilter } from '../../constants';
import baseUrl from '../../helpers/baseurl';
import { retrieveCustomDate, validateDate } from "../../helpers/dateHelper";
import { GenetalStatusModal } from './GeneralStatusModal';
import { NewServiceModal } from './NewServiceModal';
import { LabRequestCanvasStatus } from './StatusCanvas';
import { StatusModal } from './StatusModal';
import { userRoles } from '../../shared';
import { labRequestStatus, labRequestGeneralStatusCategory, labRequestGeneralStatus } from '../../shared/config/labRequestStatus';

import { BaseCustomButton, BaseSelectComponent } from '../../shared';
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from '../../constants/tables';

export const DateFieldWrapper = ({
    label,
    className,
    dateFilter,    // '1', '2', '3', or ''
    value,         // initialDate / endDate
    onChange,      // onSetStartDate / onSetEndDate
    error,         // startError / endError
}) => {
    const [showWarning, setShowWarning] = useState(false);

    // If the user clicks the date field without selecting a dateFilter, show a warning
    useEffect(() => {
        if (dateFilter === '') {
            setShowWarning(false);
        }
    }, [dateFilter]);

    const handleClick = (e) => {
        //If there is NO dateFilter, prevent the action and show the warning
        if (!dateFilter) {
            e.preventDefault();
            setShowWarning(true);
        }
    };

    return (
        <div className={className}>
            <label className="text-primary">{label}</label>
            <div onClick={handleClick} style={{ position: 'relative' }}>
                <Input
                    type="date"
                    value={value}
                    onChange={onChange}
                    disabled={!dateFilter}
                    className={`form-control rounded-3 text-primary ${error ? 'border border-danger' : ''}`}
                />

                {!dateFilter && showWarning && (
                    <small
                        className="text-danger"
                        style={{ fontSize: '11px', position: 'absolute', top: '100%', left: 0 }}
                    >
                        Debe seleccionar un tipo de fecha
                    </small>
                )}
            </div>

            {error && (
                <small className="text-danger" style={{ fontSize: '13px' }}>
                    {error}
                </small>
            )}
        </div>
    );
};

const LabCitec = (props) => {
    // * Redux
    const dispatch = useDispatch();
    const { location } = props;

    const {
        users,
        labs,
        labRequests,
        loading,
        labRequest,
        total,
        currentPage,
        advisers,
        coordinations,
        labsegments,
        labareas,
        products,
        customers,
        regions,
        labtypes,
        serviceTypes
    } = useSelector(state => ({
        labRequests: state.labRequestReducer.labRequests,
        labs: state.labsReducer.labs,
        loading: state.labRequestReducer.loading,
        labRequest: state.labRequestReducer.labRequest,
        total: state.labRequestReducer.total,
        currentPage: state.labRequestReducer.currentPage,
        advisers: state.technicalAdvisers.technicalAdvisers,
        coordinations: state.coordinations.coordinations,
        labsegments: state.labSegments.labsegments,
        labareas: state.labAreas.labareas,
        products: state.products.products,
        customers: state.customersReducer.customers,
        users: state.usersReducer.users,
        regions: state.regions.regions,
        labtypes: state.labType.labtypes,
        serviceTypes: state.serviceTypes.serviceTypes,
    }), shallowEqual);
    // * Redux fin

    // Lab Info (computed dynamically from the route)
    const isMovil = props.location.pathname.includes('/labmoviles');
    const expectedType = isMovil ? 'Móvil' : 'CITEC';
    const currentLabTypeObj = labtypes?.find(x => x.name === expectedType);
    const labId = currentLabTypeObj?.id || (isMovil ? 'C5D3DCA8-4FB7-ED11-AF88-00505689CFE4' : 'C6D3DCA8-4FB7-ED11-AF88-00505689CFE4');
    const labType = expectedType;

    const [generalStatus, setGeneralStatus] = useState(labRequestGeneralStatusCategory.inProgress);

    const [activeTab, setActiveTab] = useState('1');
    const handleTabChange = tab => {
        if (activeTab !== tab) {
            setActiveTab(tab);
            if (tab === '2') {
                setGeneralStatus(labRequestGeneralStatusCategory.rejected)
                fetchLabRequests({
                    withFilters: false,
                    clearFilters: true,
                    paginationParams: `?limit=${rejectedPageSize}&page=${DEFAULT_PAGE}`,
                    generalRequestStatus: labRequestGeneralStatusCategory.rejected
                })
            } else {
                setGeneralStatus(labRequestGeneralStatusCategory.inProgress)
                fetchLabRequests({
                    withFilters: false,
                    clearFilters: true,
                    paginationParams: `?limit=${inProgressPageSize}&page=${DEFAULT_PAGE}`,
                    generalRequestStatus: labRequestGeneralStatusCategory.inProgress
                })
            }
        }
    }

    const role = (localStorage.getItem("authUser")) ? JSON.parse(localStorage.getItem("authUser"))?.role : ''
    const obj = JSON.parse(localStorage.getItem("authUser"))
    const [user, setUser] = useState(obj.id);

    // State for date error handling
    const [dateErrors, setDateErrors] = useState({ start: '', end: '' });
    // New Service Request Modal
    const [showNewRequestModal, setShowNewRequestModal] = useState(false);
    // Request Status Change Modal
    const [showRequestStatusModal, setShowRequestStatusModal] = useState(false);
    // Pending Status Confirmation Modal
    const [showPendingStatusConfirmModal, setShowPendingStatusConfirmModal] = useState(false);
    // General Status Change Modal
    const [showGeneralStatusModal, setShowGeneralStatusModal] = useState(false);

    const [rowInfo, setRowInfo] = useState();
    const [justSubmitted, setJustSubmitted] = useState(false);
    const prevRequestsLength = React.useRef(0);
    // Flag para evitar doble fetch en el montaje inicial
    const isFirstMount = React.useRef(true);

    // Canvas Hook
    const [showManagementCanvas, setShowManagementCanvas] = useState(false);

    // Pagination
    const [inProgressPageSize, setInProgressPageSize] = useState(DEFAULT_PAGE_SIZE);
    const [rejectedPageSize, setRejectedPageSize] = useState(DEFAULT_PAGE_SIZE);
    const [paginationQuery, setPaginationQuery] = useState(`?limit=${DEFAULT_PAGE_SIZE}&page=${DEFAULT_PAGE}`)
    // Filters
    const [searchType, setSearchType] = useState('');
    let [filterQuery, setFilterQuery] = useState('');
    let [labAreaFilter, setLabAreaFilter] = useState('');
    let [segmentFilter, setSegmentFilter] = useState('');
    let [coordinationFilter, setCoordinationFilter] = useState('');
    let [customerFilter, setCustomerFilter] = useState('');
    let [adviserFilter, setAdviserFilter] = useState('');
    let [codeFilter, setCodeFilter] = useState('');
    let [searchFilter, setSearchFilter] = useState('');
    let [statusFilter, setStatusFilter] = useState('');
    let [userFilter, setUserFilter] = useState('');
    let [dateFilter, setDateFilter] = useState('');
    const [initialDate, setInitialDate] = useState('');
    const [endDate, setEndDate] = useState('');
    // Dropdown data
    const [laboratorist, setLaboratorist] = useState([]);
    const [techAdviser, setTechAdviser] = useState([]);

    const resetFilters = () => {
        setAdviserFilter('')
        setLabAreaFilter('')
        setSegmentFilter('')
        setCoordinationFilter('')
        setCustomerFilter('')
        setUserFilter('')
        setCodeFilter('')
        setSearchFilter('')
        setStatusFilter('')
        setDateFilter('')
        setInitialDate('')
        setEndDate('')
        setSearchType('')
        setFilterQuery('')
        setDateErrors({ start: '', end: '' });
    }

    const fetchLabRequests = ({
        withFilters = false,
        clearFilters = false,
        filters = filterQuery,
        generalRequestStatus = generalStatus,
        paginationParams = `?limit=${activeTab === '1' ? inProgressPageSize : rejectedPageSize}&page=${DEFAULT_PAGE}`,
    }) => {
        if (withFilters) {
            if (statusFilter) {
                dispatch(getLabRequests(
                    `${paginationParams}&laboratoryType=${labId}${filters}`
                ));
            } else {
                dispatch(getLabRequests(
                    `${paginationParams}&laboratoryType=${labId}&generalRequestStatus=${(generalRequestStatus)}${filters}`
                ));
            }
        } else {
            if (clearFilters) {
                resetFilters();
            }
            dispatch(getLabRequests(`${paginationParams}&laboratoryType=${labId}&generalRequestStatus=${(generalRequestStatus)}`));
        }
    }

    // Sync localStorage with current labType and labId
    useEffect(() => {
        localStorage.setItem("lType", JSON.stringify(labType));
        localStorage.setItem("lId", JSON.stringify(labId));
    }, [labType, labId]);

    // Fetch static catalogs once on mount
    useEffect(() => {
        const timers = [];

        if (!coordinations || coordinations.length === 0) {
            dispatch(getCoordinations(`?limit=4000&page=${DEFAULT_PAGE}&recordStatus=enable`));
        }
        
        timers.push(setTimeout(() => {
            if (!labsegments || labsegments.length === 0) {
                dispatch(getLabSegments(`?limit=4000&page=${DEFAULT_PAGE}&recordStatus=enable`));
            }
        }, 100));

        timers.push(setTimeout(() => {
            if (!customers || customers.length === 0) {
                dispatch(getCustomers(`?limit=4000&page=${DEFAULT_PAGE}&recordStatus=enable`));
            }
        }, 200));

        timers.push(setTimeout(() => {
            if (!users || users.length === 0) {
                dispatch(getUsers(`?limit=4000&page=${DEFAULT_PAGE}`));
            }
        }, 300));

        timers.push(setTimeout(() => {
            if (!regions || regions.length === 0) {
                dispatch(getRegions(`?limit=4000&page=${DEFAULT_PAGE}&recordStatus=enable`));
            }
        }, 400));

        timers.push(setTimeout(() => {
            if (!labtypes || labtypes.length === 0) {
                dispatch(getLabTypes('?limit=100&page=0'));
            }
        }, 500));

        timers.push(setTimeout(() => {
            if (!serviceTypes || serviceTypes.length === 0) {
                dispatch(getServiceTypes('?limit=4000&page=0&recordStatus=enable'));
            }
        }, 600));

        return () => {
            timers.forEach(clearTimeout);
        };
    }, [dispatch]);

    // Fetch lab-specific data on mount and whenever labId or labType changes
    useEffect(() => {
        fetchLabRequests({ withFilters: false, clearFilters: false });
        const timers = [];

        if (!labareas || labareas.length === 0) {
            dispatch(getLabAreas(`?limit=4000&page=${DEFAULT_PAGE}&recordStatus=enable&search=${encodeURI(labType)}`));
        }

        timers.push(setTimeout(() => {
            if (!products || products.length === 0) {
                if (labType === 'Móvil') {
                    dispatch(getProducts(`?limit=4000&page=${DEFAULT_PAGE}&recordStatus=enable&search=Móvil`));
                } else if (labType === 'CITEC') {
                    dispatch(getProducts(`?limit=4000&page=${DEFAULT_PAGE}&recordStatus=enable&search=CITEC`));
                }
            }
        }, 150));

        timers.push(setTimeout(() => {
            if (!labs || labs.length === 0) {
                dispatch(getLabs(`?limit=4000&page=${DEFAULT_PAGE}&recordStatus=enable&search=${labType}`));
            }
        }, 300));

        return () => {
            timers.forEach(clearTimeout);
        };
    }, [dispatch, labId, labType]);

    // Re-fetch when user navigates back (location.key changes), but skip the very first mount
    // to avoid duplicating the fetch already done by the [labId, labType] effect above.
    useEffect(() => {
        if (isFirstMount.current) {
            isFirstMount.current = false;
            return;
        }
        if (labId) {
            fetchLabRequests({ withFilters: false, clearFilters: false });
        }
    }, [location.key]);

    useEffect(() => {
        if (justSubmitted && labRequests.length > prevRequestsLength.current) {
            setJustSubmitted(false);
            fetchLabRequests({ withFilters: false, clearFilters: true });
        }
        prevRequestsLength.current = labRequests.length;
    }, [labRequests, justSubmitted]);

    useEffect(() => {
        setTechAdviser(users?.filter(x => x.userType === 'Asesor Técnico'))
        setLaboratorist(users?.filter(x => x.role === 'Laboratorista'))
    }, [users]);

    const getRequestDate = (row) => {
        const createdRecordAtDate = validateDate(row.createdRecordAt) ? moment(row.createdRecordAt).format('YYYY-MM-DD') : '';
        if (createdRecordAtDate !== '') {
            return createdRecordAtDate;
        }
        return retrieveCustomDate(
            row.requestStatus,
            row.updatedAt,
            row.createdAt,
            row.createdRecordAt
        );
    }

    const SubmitLabRequest = (values) => {
        const updValue = {
            ...values,
            startedAt: null,
            endedAt: null,
            email: 'tester@gmail.com',
            address: 'Calle 3',
            phone: '5534239582'
        }
        dispatch(addNewLabRequest(updValue))
        setJustSubmitted(true);
        setRowInfo('')
    }

    // Data for table header (Backend)
    const columns = React.useMemo(
        () => [
            {
                Header: 'Detalle',
                width: '26%',
                Cell: ({ row }) => (
                    <div>
                        <div className='text-left'><b>Folio:</b> {row.original.code ?? '-'}</div>

                        <div className='text-left'><b>Cliente:</b> {row.original.customer?.name ?? '-'}</div>

                        <div className='text-left'><b>Asesor Técnico:</b> {row.original.technicalAdviser?.name ?? '-'} {row.original.technicalAdviser?.surname ?? ''}</div>

                        <hr className='text-success mt-3' />

                        <div className='text-left'><b>Tipo de Laboratorio: </b>{row.original.laboratoryArea?.laboratoryType?.name ?? '-'} </div>
                        <div className='text-left'><b>Área de Laboratorio:</b> {row.original.laboratoryArea?.name ?? '-'} </div>
                        <div className='text-left'><b>Región:</b> {row.original.region?.state ?? '-'} {row.original.region?.municipality ?? ''}</div>
                        <div className='text-left'><b>Coordinación:</b> {row.original.coordination?.name ?? '-'}</div>
                        <div className='text-left'><b>Segmento:</b> {row.original.laboratorySegment?.name ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Laboratoristas asignados',
                width: '14%',
                Cell: ({ row }) => {
                    const getAssignedUsersText = (processName) => {
                        const assignments = row.original.labRequestAssignment;
                        if (!assignments || !Array.isArray(assignments)) return '-';
                        const users = assignments
                            .filter(x => x.statusAssignment?.toLowerCase() === processName.toLowerCase() && x.user)
                            .map(x => `${x.user.name ?? ''} ${x.user.surname ?? ''}`.trim())
                            .filter(Boolean);
                        const uniqueUsers = [...new Set(users)];
                        return uniqueUsers.length > 0 ? uniqueUsers.join(', ') : '-';
                    };

                    return (
                        <div>
                            <div className='text-left'><b>Validación de Muestras:</b></div>
                            <div className='text-left'>
                                {getAssignedUsersText('validación de muestras')}
                            </div>
                            <div className='text-left'><b>Validación de Informes:</b></div>
                            <div className='text-left'>
                                {getAssignedUsersText('validación de informes')}
                            </div>
                            <div className='text-left'><b>Pruebas de laboratorio:</b></div>
                            <div className='text-left'>
                                {getAssignedUsersText('pruebas de laboratorio')}
                            </div>
                        </div>
                    );
                },
            },
            {
                Header: 'Tipo de ensayo',
                width: '18%',
                Cell: ({ row }) => (
                    <div>
                        <div className='text-left'>{row.original.description ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Fechas de Atención',
                width: '16%',
                Cell: ({ row }) => (
                    <div>
                        <div className='text-left'><b>Fecha de Solicitud:</b></div>
                        <div className={'text-left'}>
                            {
                                getRequestDate(row.original)
                            }
                        </div>
                        <hr className='text-success' />
                        <div className='text-left'><b>Fecha de recepción de muestras:</b></div>
                        <div className='text-left'>{row.original.startedAt ? moment.utc(row.original.startedAt).format('YYYY-MM-DD') : '-'}</div>
                        <hr className='text-success' />
                        <div className='text-left'><b>Fecha de aceptación de solicitud:</b></div>
                        <div className='text-left'>{row.original.endedAt ? moment(row.original.endedAt).utc().format('YYYY-MM-DD') : '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Fechas de Ensayo / Informe',
                width: '16%',
                Cell: ({ row }) => {
                    const report = row.original.labRequestReport?.[0] || row.original.labRequestReports?.[0];
                    const essaysStartedAt = report?.essaysStartedAt ? moment(report.essaysStartedAt).utc().format('YYYY-MM-DD') : '-';
                    const essaysEndedAt = report?.essaysEndedAt ? moment(report.essaysEndedAt).utc().format('YYYY-MM-DD') : '-';
                    const endedAt = report?.endedAt ? moment(report.endedAt).utc().format('YYYY-MM-DD') : '-';
                    return (
                        <div>
                            <div className='text-left'><b>Inicio de ensayos:</b></div>
                            <div className='text-left'>{essaysStartedAt}</div>
                            <hr className='text-success' />
                            <div className='text-left'><b>Final de ensayo:</b></div>
                            <div className='text-left'>{essaysEndedAt}</div>
                            <hr className='text-success' />
                            <div className='text-left'><b>Entrega informe final:</b></div>
                            <div className='text-left'>{endedAt}</div>
                        </div>
                    );
                }
            },
            {
                Header: 'Estatus',
                width: "5%",
                Cell: ({ row }) => (
                    <div>
                        {
                            row.original.requestStatus === labRequestStatus.pending ?
                                <div className='text-warning'>{labRequestStatus.pending}</div> :
                                row.original.requestStatus === labRequestStatus.accepted ?
                                    <div className='text-success'>{labRequestStatus.accepted}</div> :
                                    row.original.requestStatus === labRequestStatus.rejected ?
                                        <div className='text-danger'>{labRequestStatus.rejected}</div> :
                                        row.original.requestStatus === labRequestStatus.completed ?
                                            <div className='text-success'>{labRequestStatus.completed}</div> :
                                            row.original.requestStatus === labRequestStatus.waiting ?
                                                <div className='text-center' style={{ color: '#1994EC' }}>{labRequestStatus.waiting}</div> :
                                                row.original.requestStatus === labRequestStatus.cancelled ?
                                                    <div className='text-danger'>{labRequestStatus.cancelled}</div> : ''
                        }
                        <hr className='text-success' />
                        {
                            row.original.generalStatus === labRequestGeneralStatus.completed ?
                                <div className='text-success'>{labRequestGeneralStatus.completed}</div> :
                                row.original.generalStatus === labRequestGeneralStatus.cancelled ?
                                    <div className='text-danger'>{labRequestGeneralStatus.cancelled}</div> : ''
                        }
                    </div>

                ),
            },
            {
                width: '5%',
                Header: "Acciones",
                Cell: ({ row }) => (
                    <div className="page-title-box d-flex align-items-center justify-content-center row">
                        <Link
                            to={{
                                pathname: `/labCitec/${row.original.id}`,
                                query: {
                                    user: user,
                                    props: props,
                                    id: labId,
                                    labType: labType
                                }
                            }}
                        >
                            <BaseCustomButton
                                color="success"
                                outline
                                className="col-10 mb-2 p-1"
                                icon="mdi-lead-pencil mdi-18px"
                                label="Editar"
                                style={{
                                    width: '100%',
                                }}
                            />
                        </Link>

                        <BaseCustomButton
                            color="primary"
                            outline
                            className="col-10 mb-2 p-1"
                            icon="mdi-cog mdi-18px"
                            label={role === userRoles.technicalAdvisor ? "Enviar Solicitud" : "Estatus (Solicitud)"}
                            onClick={() => onUpdateStatus(row.original)}
                            disabled={
                                role === userRoles.laboratorist ||
                                row.original.requestStatus === labRequestStatus.rejected ||
                                row.original.requestStatus === labRequestStatus.accepted ||
                                (role === userRoles.technicalAdvisor && row.original.requestStatus !== labRequestStatus.pending)
                            }
                        />

                        <BaseCustomButton
                            color="primary"
                            outline
                            className="col-10 mb-2 p-1"
                            icon="mdi-power mdi-18px"
                            label="Estatus (General)"
                            onClick={() => onUpdateGeneralStatus(row.original)}
                            disabled={role === "Laboratorista" || role === "Asesor Técnico"}
                        />

                        <BaseCustomButton
                            color="warning"
                            outline
                            icon="mdi mdi-bell-circle-outline"
                            label="Gestión"
                            onClick={() => displayManagementCanvas(row.original)}
                            style={{
                                height: '49px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '86%',
                            }}
                        />
                    </div>
                ),
            },
        ],
        []
    )

    const onUpdateStatus = (status) => {
        setRowInfo(status)
        setShowRequestStatusModal(true)
    }

    const onUpdateGeneralStatus = (status) => {
        setRowInfo(status)
        setShowGeneralStatusModal(true)
    }

    const displayManagementCanvas = (status) => {
        dispatch(getLabRequest(`/${status.id}`))
        setTimeout(
            () => {
                setRowInfo(status)
                setShowManagementCanvas(!showManagementCanvas)
            }
            , 400)
    }

    const updateRequestStatus = (values) => {
        const updVal = {
            ...values,
            id: rowInfo.id,
            statusOnly: true,
        }
        if (values.requestStatus === labRequestStatus.pending) {
            setShowPendingStatusConfirmModal(true)
        }
        else {
            dispatch(updateLabRequest(updVal))
        }

    }

    const updateGeneralRequestStatus = (values, onSuccess, onFail) => {
        const updVal = {
            ...values,
            id: rowInfo.id,
            statusOnly: true,
            onSuccess,
            onFail
        }
        dispatch(updateLabRequest(updVal))
    }

    const onDateFilterChange = (selectObject) => {
        const newFilter = selectObject?.value ?? ''; // it will be '1', '2', '3', or ''

        if (newFilter === '') {
            //The user selected "Select date type" again 
            setDateFilter('');
            // (Opcional) Clean/Reset date fields:
            setInitialDate('');
            setEndDate('');
        } else {
            // The user chose a real date type
            setDateFilter(newFilter);
        }
    };


    const handleSearchTypeChange = (selectObject) => {
        setSearchType(selectObject?.value ?? '');
        setLabAreaFilter('')
        setSegmentFilter('')
        setCoordinationFilter('')
        setUserFilter('')
        setCustomerFilter('')
        setAdviserFilter('')
        setCodeFilter('')
        setSearchFilter('')
        setStatusFilter('')
    }

    const onClickSearch = () => {
        setDateErrors({ start: '', end: '' });

        if (dateFilter && (!initialDate || !endDate)) {
            let newErrors = { start: '', end: '' };
            if (!initialDate) newErrors.start = 'Fecha de inicio requerida';
            if (!endDate) newErrors.end = 'Fecha de fin requerida';
            // we save the errors so that DateFieldWrapper can display them on the screen.
            setDateErrors(newErrors);
            return;
        }

        let filters = '';

        if (searchType === '1') {
            if (labAreaFilter) filters += `&laboratoryArea=${labAreaFilter}`;
            if (segmentFilter) filters += `&laboratorySegment=${segmentFilter}`;
            if (coordinationFilter) filters += `&coordination=${coordinationFilter}`;
            if (userFilter) filters += `&assignmentUser=${userFilter.id}`;
        }
        if (searchType === '2') {
            const params = []
            if (customerFilter) params.push(`customer=${customerFilter.id}`)
            if (adviserFilter) params.push(`technicalAdviser=${adviserFilter.id}`)
            filters = params.length ? `&${params.join('&')}` : ''
        }
        else if (searchType === '3') {
            const params = []
            if (searchFilter) params.push(`search=${searchFilter}`)
            if (codeFilter) params.push(`code=${codeFilter}`)
            if (statusFilter) params.push(`requestStatus=${statusFilter}`)
            filters = params.length ? `&${params.join('&')}` : ''
        }

        if (dateFilter === '1') {
            if (initialDate !== '' && endDate !== '') {
                filters += `&dateFilterType=request_date&initialDatedAt=${initialDate}&finalDatedAt=${endDate}`;
            }
        }
        else if (dateFilter === '2') {
            if (initialDate !== '' && endDate !== '') {
                filters += `&dateFilterType=initial_date&initialDatedAt=${initialDate}&finalDatedAt=${endDate}`;
            }
        }
        else if (dateFilter === '3') {
            if (initialDate !== '' && endDate !== '') {
                filters += `&dateFilterType=final_date&initialDatedAt=${initialDate}&finalDatedAt=${endDate}`;
            }
        }

        setFilterQuery(filters);

        // API call
        fetchLabRequests({ withFilters: true, filters: filters });
    };

    const getPagination = (params) => {
        setPaginationQuery(params);
        fetchLabRequests({ withFilters: true, paginationParams: params });
    };

    const onAcceptSendingRequest = () => {
        const updVal = {
            requestStatus: labRequestStatus.pending,
            id: rowInfo.id,
        }
        dispatch(updateLabRequest(updVal))
        setTimeout(() => {
            fetchLabRequests({ withFilters: true });
            props.history.push(`/process-notification/${rowInfo.id}`,
                { state: { validateProcess: 'Proceso de validación', validationStatus: 'Proceso de validación' } })
        }, 250)
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid className="" >
                    <Col className="col-12" style={{ padding: 40 }}>
                        <Card className='' style={{ padding: 18 }}>

                            {
                                labType === 'CITEC' ?
                                    <Breadcrumb breadcrumbItem1='labCitec' /> : <Breadcrumb breadcrumbItem1='labMoviles' />
                            }

                            <Card className='' style={{ padding: 20 }}>

                                <div className="d-flex align-items-center justify-content-end mb-3">
                                    <Link to={{
                                        pathname: `/home`,
                                    }}
                                        className="btn btn-success rounded-3 py-2">
                                        <span className="mdi mdi-keyboard-backspace me-2"></span>Atrás
                                    </Link>
                                </div>

                                <div className="row d-flex justify-content-center align-items-center">
                                    <div className='col-12 col-md-6 col-lg-3'>
                                        <label className="text-primary ml-1 rounded-3">Tipo de Búsqueda</label>
                                        <BaseSelectComponent
                                            options={[
                                                { value: '1', label: 'Información del Servicio' },
                                                { value: '2', label: 'Información del Cliente' },
                                                { value: '3', label: 'Estatus del servicio' }
                                            ]}
                                            onChangeAsObject={true}
                                            value={searchType}
                                            onChange={handleSearchTypeChange}
                                            placeholder={'Seleccione el tipo de búsqueda'}
                                        />
                                    </div>

                                    <div className='col-12 col-md-6 col-lg-3'>
                                        <label htmlFor="exampleInputEmail" className="text-primary ml-1 rounded-3">Tipo de Fecha</label>
                                        <BaseSelectComponent
                                            options={[
                                                { value: '1', label: 'Fecha de Solicitud (creación)' },
                                                { value: '2', label: 'Fecha de recepción de muestras' },
                                                { value: '3', label: 'Fecha de aceptación de solicitud' }
                                            ]}
                                            onChangeAsObject={true}
                                            value={dateFilter}
                                            onChange={onDateFilterChange}
                                            placeholder={'Seleccione el tipo de fecha'}
                                        />
                                    </div>

                                    <DateFieldWrapper
                                        className={"col-12 col-md-6 col-lg-2"}
                                        label="Fecha Inicio"
                                        dateFilter={dateFilter} // THE state variable that defines if it is '' or '1','2','3'
                                        value={initialDate}
                                        onChange={(e) => setInitialDate(e.target.value)}
                                        error={dateErrors.start}
                                    />

                                    <DateFieldWrapper
                                        className={"col-12 col-md-6 col-lg-2"}
                                        label="Fecha Fin"
                                        dateFilter={dateFilter}
                                        value={endDate}
                                        onChange={(e) => setEndDate(e.target.value)}
                                        error={dateErrors.end}
                                    />

                                    <div className="col-12 col-md-6 col-lg-2 mt-4">
                                        <BaseCustomButton
                                            onClick={onClickSearch}
                                            label="Buscar"
                                            icon="mdi mdi-magnify me-1"
                                            color="dark"
                                            className="w-100"
                                        />
                                    </div>
                                </div>

                                {
                                    (searchType === '1') ? (
                                        <div>
                                            <div className="row ml-2 mr-2 mb-2">
                                                <div className="col-3 col-md-6">
                                                    <label className='text-primary ml-1'>Área de Laboratorio</label>
                                                    <BaseSelectComponent
                                                        options={labareas.map((dir) => ({ value: dir.id, label: dir.name }))}
                                                        value={
                                                            labAreaFilter
                                                                ? labareas
                                                                    .map((dir) => ({ value: dir.id, label: dir.name }))
                                                                    .find((opt) => opt.value === labAreaFilter) || null
                                                                : null
                                                        }
                                                        onChangeAsObject={true}
                                                        onChange={(selectedOption) => {
                                                            if (selectedOption) {
                                                                setLabAreaFilter(selectedOption.value);
                                                            } else {
                                                                setLabAreaFilter('');
                                                            }
                                                        }
                                                        }
                                                        placeholder="Seleccione el tipo de laboratorio"
                                                    />
                                                </div>
                                                <div className="col-3 col-md-6">
                                                    <label className='text-primary ml-1'>Segmento</label>
                                                    <BaseSelectComponent
                                                        options={labsegments.map((dir) => ({
                                                            value: dir.id,
                                                            label: dir.name,
                                                        }))}
                                                        value={
                                                            segmentFilter
                                                                ? labsegments
                                                                    .map((dir) => ({ value: dir.id, label: dir.name }))
                                                                    .find((opt) => opt.value === segmentFilter) || null
                                                                : null
                                                        }
                                                        onChangeAsObject={true}
                                                        onChange={(selectedOption) => {
                                                            if (selectedOption) {
                                                                setSegmentFilter(selectedOption.value);
                                                            } else {
                                                                setSegmentFilter('');
                                                            }
                                                        }}
                                                        placeholder="Seleccione el tipo de Segmento"
                                                    />
                                                </div>
                                            </div>

                                            <div className="row ml-2 mr-2 mb-2">
                                                <div className="col-3 col-md-6">
                                                    <label className='text-primary ml-1'>Laboratorista</label>
                                                    <BaseSelectComponent
                                                        placeholder="Seleccione Laboratorista..."
                                                        options={laboratorist.map(item => ({
                                                            value: item.id,
                                                            label: `${item.name ?? '-'} ${item.surname ?? ''}`,
                                                        }))}
                                                        value={
                                                            userFilter
                                                                ? {
                                                                    value: userFilter.id,
                                                                    label: `${userFilter.name ?? '-'} ${userFilter.surname ?? ''}`
                                                                }
                                                                : null
                                                        }
                                                        onChangeAsObject={true}
                                                        onChange={(selectedOption) => {
                                                            if (selectedOption) {
                                                                const foundUser = laboratorist.find(u => u.id === selectedOption.value);
                                                                setUserFilter(foundUser || null);
                                                            } else {
                                                                setUserFilter(null);
                                                            }
                                                        }}
                                                    />
                                                </div>

                                                <div className="col-3 col-md-6">
                                                    <label className='text-primary ml-1'>Coordinación</label>
                                                    <BaseSelectComponent
                                                        options={coordinations.map((dir) => ({
                                                            value: dir.id,
                                                            label: dir.name,
                                                        }))}
                                                        value={
                                                            coordinationFilter
                                                                ? coordinations
                                                                    .map((dir) => ({ value: dir.id, label: dir.name }))
                                                                    .find((opt) => opt.value === coordinationFilter) || null
                                                                : null
                                                        }
                                                        onChangeAsObject={true}
                                                        onChange={(selectedOption) => {
                                                            if (selectedOption) {
                                                                setCoordinationFilter(selectedOption.value);
                                                            } else {
                                                                setCoordinationFilter('');
                                                            }
                                                        }}
                                                        placeholder="Seleccione la Coordinación"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ) :
                                        (searchType === '2') ?
                                            <div className="row ml-2 mr-2 mb-4">
                                                <div className="col-3 col-md-6">
                                                    <label className='text-primary ml-1'>Cliente</label>
                                                    <BaseSelectComponent
                                                        placeholder="Seleccione Cliente..."
                                                        options={customers.map(item => ({
                                                            value: item.id,
                                                            label: item.name ?? '-',
                                                        }))}
                                                        value={
                                                            customerFilter
                                                                ? { value: customerFilter.id, label: customerFilter.name ?? '-' }
                                                                : null
                                                        }
                                                        onChangeAsObject={true}
                                                        onChange={(selectedOption) => {
                                                            if (selectedOption) {
                                                                const foundCustomer = customers.find(c => c.id === selectedOption.value);
                                                                setCustomerFilter(foundCustomer || null);
                                                            } else {
                                                                setCustomerFilter(null);
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-3 col-md-6">
                                                    <label className='text-primary ml-1'>Asesor Técnico</label>
                                                    <BaseSelectComponent
                                                        placeholder="Seleccione Asesor Técnico..."
                                                        options={techAdviser.map(item => ({
                                                            value: item.id,
                                                            label: `${item.name ?? '-'} ${item.surname ?? ''}`,
                                                        }))}
                                                        value={
                                                            adviserFilter
                                                                ? {
                                                                    value: adviserFilter.id,
                                                                    label: `${adviserFilter.name ?? '-'} ${adviserFilter.surname ?? ''}`
                                                                }
                                                                : null
                                                        }
                                                        onChangeAsObject={true}
                                                        onChange={(selectedOption) => {
                                                            if (selectedOption) {
                                                                const foundAdviser = techAdviser.find(t => t.id === selectedOption.value);
                                                                setAdviserFilter(foundAdviser || null);
                                                            } else {
                                                                setAdviserFilter(null);
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div> :
                                            (searchType === '3') ?
                                                <div className="row ml-2 mr-2 mb-4">
                                                    <div className="col-3 col-md-4">
                                                        <label className='text-primary ml-1'>Descripción</label>
                                                        <div className="form-outline w-100 me-2">
                                                            <input
                                                                type="search"
                                                                id="form1"
                                                                className="form-control rounded-3"
                                                                placeholder="Descripción"
                                                                aria-label="Search"
                                                                value={searchFilter}
                                                                onChange={e => setSearchFilter(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-3 col-md-4">
                                                        <label className='text-primary ml-1'>Folio</label>
                                                        <div className="form-outline w-100 me-2">
                                                            <input
                                                                type="search"
                                                                id="form1"
                                                                className="form-control rounded-3"
                                                                placeholder="Folio"
                                                                value={codeFilter}
                                                                aria-label="Search"
                                                                onChange={e => setCodeFilter(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                    {
                                                        activeTab === '1' ?
                                                            <div className="col-3 col-md-4">
                                                                <label className='text-primary ml-1'>Estatus</label>
                                                                <Tooltip
                                                                    title="Para acceder a las solicitudes rechazadas, cambie a la pestaña de 'Rechazadas'"
                                                                    placement="top"
                                                                    arrow
                                                                    color='#1D4370'
                                                                    mouseEnterDelay={0.6}
                                                                >
                                                                    <BaseSelectComponent
                                                                        options={mainRequestStatusFilter
                                                                            .filter((dir) => dir.id !== 'Rechazada')
                                                                            .map((dir) => ({
                                                                                value: dir.id,
                                                                                label: dir.value,
                                                                            }))
                                                                        }
                                                                        value={
                                                                            statusFilter
                                                                                ? mainRequestStatusFilter
                                                                                    .map((dir) => ({ value: dir.id, label: dir.value }))
                                                                                    .find((opt) => opt.value === statusFilter) || null
                                                                                : null
                                                                        }
                                                                        onChangeAsObject={true}
                                                                        onChange={(selectedOption) => {
                                                                            if (selectedOption) {
                                                                                setStatusFilter(selectedOption.value);
                                                                            } else {
                                                                                setStatusFilter('');
                                                                            }
                                                                        }}
                                                                        placeholder="Seleccione Estatus"
                                                                    />
                                                                </Tooltip>
                                                            </div> : null
                                                    }
                                                </div> : null
                                }


                                <div className="page-title-box d-flex align-items-center justify-content-end mt-4" >
                                    <br />
                                    <br />
                                    <div className='col-3 col-md-2 mx-2'>
                                        <Link className='btn rounded-3 w-100'
                                            to={{
                                                pathname: `${baseUrl}lab-requests/export-to-excel${paginationQuery}&generalRequestStatus=${generalStatus}&laboratoryType=${labId}${filterQuery}`,
                                            }} target='_blank'
                                        >
                                            <button className='btn rounded-3 w-100' style={{ backgroundColor: 'green', color: 'white' }}>
                                                <span className="mdi mdi-22px mdi-file-excel me-2"></span>Exportar
                                            </button>
                                        </Link>

                                    </div>
                                    <div className='col-3 col-md-2 mx-2'>
                                        <Link to="/notifications">
                                            <button type='button' className="btn btn-warning py-2 w-100 rounded-3" >
                                                <span className="mdi mdi-bell me-2"></span>Notificaciones
                                            </button>
                                        </Link>
                                    </div>

                                    <Link
                                        to="/labCitecScheduledTests"
                                        className='col-3 col-md-2 mx-2'
                                    >
                                        <button className='btn btn-info py-2 rounded-3 w-100'>
                                            <span className="mdi mdi-calendar-multiple me-2"></span>Pruebas Calendarizadas
                                        </button>
                                    </Link>

                                    <NewServiceRequestButton
                                        disabled={role === 'Laboratorista'}
                                        showModal={showNewRequestModal}
                                        setShowModal={setShowNewRequestModal}
                                    />

                                    <NewServiceModal
                                        regions={regions}
                                        modalRespInfo={SubmitLabRequest}
                                        props={props}
                                        showModal={showNewRequestModal}
                                        setShowModal={setShowNewRequestModal}
                                        labType={labType}
                                        customers={customers}
                                        coordinations={coordinations}
                                        advisers={users}
                                        labSegments={labsegments}
                                        products={products}
                                        labareas={labareas}
                                        labs={labs}
                                        serviceTypes={serviceTypes}
                                    />

                                </div>

                                <Nav tabs className="nav-tabs-custom nav-justified">
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({ active: activeTab === '1' })}
                                            onClick={() => { handleTabChange('1'); }}>
                                            En Proceso
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink style={{ cursor: "pointer" }}
                                            className={classnames({ active: activeTab === '2' })}
                                            onClick={() => { handleTabChange('2'); }}>Rechazadas</NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={activeTab} className="p-4">
                                    <TabPane tabId="1">
                                        <div>
                                            <Table1
                                                isAddTableBorderStrap
                                                currentPage={currentPage}
                                                getPagination={getPagination}
                                                total={total}
                                                loading={loading}
                                                columns={columns}
                                                data={labRequests}
                                                onPageSizeChange={(newPageSize) => {
                                                    setInProgressPageSize(newPageSize);
                                                }}
                                            />
                                            <br />
                                            <LabRequestCanvasStatus labRequest={labRequest} showCanvas={showManagementCanvas} setShowCanvas={setShowManagementCanvas} />
                                        </div>
                                    </TabPane>
                                </TabContent>
                                <TabContent activeTab={activeTab} className="p-4">
                                    <TabPane tabId="2">
                                        <div>
                                            <Table1
                                                currentPage={currentPage}
                                                getPagination={getPagination}
                                                total={total}
                                                loading={loading}
                                                isAddTableBorderStrap
                                                columns={columns}
                                                data={labRequests}
                                                onPageSizeChange={(newPageSize) => {
                                                    setRejectedPageSize(newPageSize);
                                                }}
                                            />
                                            <br />
                                            <LabRequestCanvasStatus labRequest={labRequest} showCanvas={showManagementCanvas} setShowCanvas={setShowManagementCanvas} />
                                        </div>
                                    </TabPane>
                                </TabContent>
                                <StatusModal
                                    role={role}
                                    modalRespInfo={updateRequestStatus}
                                    requestStatus={rowInfo}
                                    props={props}
                                    setShowModal={setShowRequestStatusModal}
                                    showModal={showRequestStatusModal}
                                />
                            </Card>
                            <ConfirmationModal
                                onAccept={onAcceptSendingRequest}
                                showModal={showPendingStatusConfirmModal}
                                setShowModal={setShowPendingStatusConfirmModal}
                                message='Esta acción cambiará el estatus de la solicitud a espera y permitirá la notificación al coordinador de la plataforma para su atención, ¿Desea continuar?'
                            />
                        </Card>
                        <GenetalStatusModal
                            role={role}
                            modalRespInfo={updateGeneralRequestStatus}
                            requestStatus={rowInfo}
                            props={props}
                            setShowModal={setShowGeneralStatusModal}
                            showModal={showGeneralStatusModal}
                        />
                    </Col>
                    <ToastContainer autoClose={2000} newestOnTop={true} />
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(LabCitec)
